export default "__VITE_ASSET__rtkEb8cA__"